import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useCustomerAuth } from "@/context/CustomerAuthContext";

// Handles the return from Emergent Google OAuth (URL fragment #session_id=...).
export default function AuthCallback() {
  const { exchangeSession } = useCustomerAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const run = async () => {
      if (!sessionId) {
        navigate("/login");
        return;
      }
      try {
        await exchangeSession(sessionId);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/orders");
      } catch (e) {
        navigate("/login?error=1");
      }
    };
    run();
  }, [exchangeSession, navigate]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[var(--brand-ink)]">
      <Loader2 className="animate-spin text-white" size={32} />
      <p className="mt-4 text-sm text-white/70">Signing you in…</p>
    </div>
  );
}
